<template>

</template>

<script>
export default {
  name: 'Coupons',
};
</script>

<style scoped>

</style>
